import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteRateApplianceMethodsAdapter = getAdapter({ idFieldName: 'value' });

const quoteRateApplianceMethodsSlice = createSlice({
  name: 'quoteRateApplianceMethods',
  initialState: quoteRateApplianceMethodsAdapter.getInitialState(),
  reducers: {
    setQuoteRateApplianceMethods: (state, { payload: { quoteRateApplianceMethods } }) => {
      quoteRateApplianceMethodsAdapter.setAll(state, quoteRateApplianceMethods);
    },
  },
});

const selectors = quoteRateApplianceMethodsAdapter.getSelectors(({ quoteRateApplianceMethods }) => quoteRateApplianceMethods);

export const getQuoteRateApplianceMethods = (state) => selectors.selectAll(state);

export const {
  setQuoteRateApplianceMethods,
} = quoteRateApplianceMethodsSlice.actions;

export default quoteRateApplianceMethodsSlice.reducer;
